import { LANGUAGES } from './types';

export enum PROD_SUPPORTED_LANGUAGES {
  en = LANGUAGES.en,
  fr = LANGUAGES.fr
}

export const PROD_DEFAULT_LANGUAGE = PROD_SUPPORTED_LANGUAGES.en;
